export const selectItemsIds = {
    WORKOUT_EXERCISES: 0,
    WEARABLE_STATS: 1,
    WORKOUT_PLAYBACK: 2,
    GENERAL_LEADERBOARDS: 3,
    WORKOUT_LEADERBOARDS: 4,
    YOUTUBE_VIDEO: 5,
};

export const chooseWorkoutItemsIds = {
    WORKOUT_OF_THE_DAY: 0,
    CHALLENGE_OF_THE_WEEK: 1,
    CUSTOM_WORKOUT: 2,
};

// ids leading to the next step
export const secondStepIds = [
    selectItemsIds.GENERAL_LEADERBOARDS,
    selectItemsIds.WORKOUT_LEADERBOARDS,
    selectItemsIds.YOUTUBE_VIDEO,
];

// ids to display duration time
export const durationTimeIds = [0, 2];



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/constants.js